import { Period } from '../context/PeriodProvider';
import { fetchAndParse } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { EditFuelTransaction, FuelTransaction } from '../types/FuelTransaction';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';
import { AddFuelTransaction as AddFuelTransactionType } from '../types/FuelTransaction';
import { Role } from '../types/Role';

export const FuelTransactionClient = (config: ClientConfig) => {
    const { userRole, accessToken, param = '' } = config;
    const headers = getHeaders(accessToken);
    const baseClientConfig = {
        useAdminRoute: userRole === Role.ADMIN && param !== '',
    };

    const getFuelTransactions = (period: Period): Promise<FuelTransaction[]> => {
        const apiUrl = `${BaseClient(baseClientConfig).getApiUrl(Endpoints.FUEL_TRANSACTION)}/${param}?quarter=${period.quarter}&year=${period.year}`;

        return fetchAndParse<FuelTransaction[]>(apiUrl, { headers });
    };

    /**
     * Gets the replacement fuel transactions (vervangend vervoer) for the given period.
     */
    const getReplacementFuelTransactions = (period: Period): Promise<FuelTransaction[]> => {
        const apiUrl = `${BaseClient(baseClientConfig).getApiUrl(Endpoints.FUEL_TRANSACTION)}/replacement/${param}?quarter=${period.quarter}&year=${
            period.year
        }`;

        return fetchAndParse<FuelTransaction[]>(apiUrl, { headers });
    };

    const addFuelTransaction = (values: AddFuelTransactionType): Promise<Response> => {
        return fetch(`${BaseClient({ role: userRole }).getApiUrl(Endpoints.FUEL_TRANSACTION)}/${param}`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ ...values }),
        });
    };

    const editFuelTransaction = (values: EditFuelTransaction): Promise<Response> => {
        return fetch(`${BaseClient({ role: userRole }).getApiUrl(Endpoints.FUEL_TRANSACTION)}`, {
            method: 'PUT',
            headers,
            body: JSON.stringify({ ...values }),
        });
    };
    const unMarkAsSubstituteCarUsage = async (id: string): Promise<Response|Error> => {
        const response = await fetch(`${BaseClient({ role: userRole }).getApiUrl(Endpoints.FUEL_TRANSACTION)}/replacement`, {
            method: 'DELETE',
            headers,
            body: JSON.stringify({ id }),
        });
        if (response.status !== 200) {
            return Promise.reject(response.statusText);
        }
        return response;
    };
    const markAsSubstituteCarUsage = async (id: string): Promise<Response|Error> => {
        const response = await fetch(`${BaseClient({role: userRole}).getApiUrl(Endpoints.FUEL_TRANSACTION)}/replacement`, {
            method: 'PUT',
            headers,
            body: JSON.stringify({id}),
        });
        if (response.status !== 200) {
            return Promise.reject(response.statusText);
        }
        return response;
    };

    const deleteFuelTransaction = (id: string): Promise<Response> => {
        return fetch(`${BaseClient({ role: userRole }).getApiUrl(Endpoints.FUEL_TRANSACTION)}`, {
            method: 'DELETE',
            headers,
            body: JSON.stringify({ id }),
        });
    };

    return {
        getFuelTransactions,
        getReplacementFuelTransactions,
        addFuelTransaction,
        editFuelTransaction,
        deleteFuelTransaction,
        markAsSubstituteCarUsage,
        unMarkAsSubstituteCarUsage,
    };
};
